import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const MarketInfoWrapper = withConfig(theme => styled('div', { label: 'MarketInfoWrapper' })`
    color: ${theme.star.betslipSelectionList.txtColorSecondary};
    margin-bottom: 8px;
    padding-right: 24px;
    width: 100%;
`);

export const InfoName = withConfig(theme => styled('div', { label: 'InfoName' })`
    display: inline;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.regular};
    line-height: 1.2;
    position: relative;
    &::after {
        content: '|';
        margin: 0 4px;
    }
    &:last-of-type,
    &:only-of-type {
        &::after {
            content: none;
        }
    }
`);
